import { makeAsyncComponent } from 'FormsUI/components/makeAsyncComponent';
const AsyncImageBrowserAndUploder = makeAsyncComponent(() => import( /* webpackChunkName: "file-picker" */'FormsUI/components/common/ImageBrowseAndUploader'));
export default AsyncImageBrowserAndUploder;